import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-partner-not-found',
  templateUrl: './partner-not-found.page.html',
  styleUrls: ['./partner-not-found.page.scss'],
  providers: []
})
export class PartnerNotFoundComponent implements OnInit {

  urlAtual = '';

  constructor(
    private route: ActivatedRoute,
  ) {  }

  ngOnInit(): void {
    this.urlAtual = window.history.state.urlAtual;
  }
  
  
}